import React from "react";

const BookmarkListSkeleton: React.FC = () => {
  return (
    <>
      {[1, 2, 3, 4, 5].map((item) => (
        <div
          className="flex items-center justify-between relative max-md:p-4 max-sm:p-2 max-md:border max-md:border-[#89D9EE] max-md:rounded-xl max-md:my-0"
          key={item}
        >
          <div className="grid grid-cols-[192px_1fr] max-lg:grid-cols-[100px_1fr] max-sm:grid-cols-[80px_1fr] items-center gap-4 w-full">
            <div className="grid h-32 max-md:h-20 place-items-center relative z-10">
              <div className="skeleton w-[192px] max-lg:w-[100px] max-sm:w-[80px] h-full"></div>
            </div>
            <div className="md:pr-3">
              <div className="flex items-center gap-3 mb-1 max-sm:mb-1 max-sm:gap-1">
                <div className="w-10 skeleton h-7 !rounded-md"></div>
                <div className="skeleton w-20 !rounded-md h-7"></div>
              </div>
              <div className="skeleton !rounded-md w-3/4 h-7"></div>
              <div className="flex justify-between items-center">
                <div className="skeleton w-40 h-7 !rounded-md mt-3"></div>
                <div className="flex justify-between gap-2 items-center">
                  <div className="skeleton h-8 w-8 !rounded-md"></div>
                  <div className="skeleton w-8 h-8 !rounded-md"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default BookmarkListSkeleton;
